import { useSession } from "@src/appV2/Auth/api/useSession";
import { WORKPLACE_TYPES } from "@src/appV2/constants/workplaceTypes";

import { useIsJobInterviewsEnabled } from "./useIsJobInterviewsEnabled";

// A hook to wrap some additional display conditions around the "Interview Availability" menu item
// This hook is used just to determine the visibility of the menu item, not the actual functionality of the page
// or routing
export function useIsInterviewAvailabilityMenuVisible(): boolean {
  const isJobInterviewsEnabled = useIsJobInterviewsEnabled();
  const { profile, admin } = useSession();

  // If the base feature flag is disabled, return false
  if (!isJobInterviewsEnabled) {
    return false;
  }

  // If user is a CBH employee (admin), always allow access
  if (admin) {
    return true;
  }

  // For Child Care Centers, disable the feature for non-CBH employees
  // For all other workplace types, follow the base feature flag
  return profile?.type !== WORKPLACE_TYPES.CHILD_CARE_CENTER;
}
